import { StrictLocalMsg } from "@faire/localization/react/StrictLocalMsg";
import { ServerSideLocalMsg } from "@faire/localization/rsc/ServerSideLocalMsg";

import { FormFieldValidationStatus } from "../form/types";
import { InstanceOfComponent } from "../shared/types";

import { TextInputStatus } from "./types";

export const getFormFieldValidationStatusForTextInput = (
  error?:
    | boolean
    | string
    | InstanceOfComponent<typeof StrictLocalMsg>
    | InstanceOfComponent<typeof ServerSideLocalMsg>,
  status?: TextInputStatus
): FormFieldValidationStatus | undefined => {
  if (!error && status === "validated") {
    return "validated";
  }
  if (status === "loading") {
    return "validating";
  }
  return undefined;
};
